export const ExchangesLinkObj: {[key: string]: string} = {
  Binance: 'https://www.binance.com',
  Bitget: 'https://www.bitget.com',
  ByBit: 'https://www.bybit.com',
  Kucoin: 'https://www.kucoin.com',
  Huobi: 'https://www.htx.com',
  GateIo: 'https://www.gate.com',
  MEXC: 'https://www.mexc.com',
  Poloniex: 'https://www.poloniex.com',
};
export const ExchangesRefLinksObj: {[key: string]: string} = {
  Binance: 'https://www.binance.com/register?ref=725TOF',
  Bitget: 'https://www.bitget.com/asia/referral/register?clacCode=8YPQ8MS6&from=%2Fasia%2Fevents%2Freferral-all-program&source=events&utmSource=PremierInviter',
  ByBit: 'https://www.bybit.com/invite?ref=KZKWE8',
  Kucoin: 'https://www.kucoin.com/r/broker/CX87SWSA',
  Huobi: 'https://www.htx.com/invite/en-us/1f?invite_code=w8ha3',
  GateIo: 'https://www.gate.com/share/A1VHVA1d',
  MEXC: 'https://www.mexc.com',
  OKX: 'https://okx.com/join/6762984',
};

export const getExchangeSpotLink = (exchange: string, market: string) => {
  switch(exchange) {
    case 'Binance': {
      const formatedMarket = market.replace("/", "_")
      return `https://www.binance.com/uk-UA/trade/${formatedMarket}?type=spot`
    }
    case 'Bitget': {
      const formatedMarket = market.replace("/", "")
      return `https://www.bitget.com/spot/${formatedMarket}`
    }
    case 'ByBit': {
      return `https://www.bybit.com/en/trade/spot/${market}`
    }
    case 'Kucoin': {
      const formatedMarket = market.replace("/", "-")
      return `https://www.kucoin.com/ru/trade/${formatedMarket}`
    }
    case 'Huobi': {
      const formatedMarket = market.replace("/", "_").toLowerCase()
      return `https://www.htx.com/trade/${formatedMarket}?type=spot`
    }
    case 'GateIo': {
      const formatedMarket = market.replace("/", "_")
      return `https://www.gate.com/uk/trade/${formatedMarket}`
    }
    case 'MEXC': {
      const formatedMarket = market.replace("/", "_")
      return `https://www.mexc.com/uk-UA/exchange/${formatedMarket}`
    }
    case 'Poloniex': {
      const formatedMarket = market.replace("/", "_")
      return `https://www.poloniex.com/trade/${formatedMarket}`
    }
  }
}

export const HIDE_NUM_FILTER_KEY: string = 'hideLowerThan';
export const HIGHLIGHT_FROM_KEY: string = 'highlightFrom';
export const FEE_FILTER_KEY: string = 'substructFeeFrom';
export const FILTER_PERCENT_KEY: string = 'filterPercent';
export const HIDDEN_EXCHANGES_KEY: string = 'HiddenExchangesKey';
export const FAVORITES_MARKETS_KEY: string = "favoriteMarkets";
export const DELETED_MARKETS_KEY: string = "deletedMarkets";
export const LANG_KEY: string = "language";